import {createStrokeSVG} from './TEMPLATE'

// lucide: case-sensitive
export const TitleCase_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'm2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16',
    'M22 9v7',
    'M3.304 13h6.392',
    'M15 12.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0Z',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
